import React from "react";
import Grid from "./Grid";
import { style } from "typestyle";

const LabelsRow = () => (
  <div
    className={style({
      display: "flex",
      overflow: "hidden",
      $nest: {
        "&>*": {
          width: "100%",
          fontSize: "14px",
          lineHeight: "20px",
          padding: "0px 12px",
        },
      },
    })}
  >
    <div>Northing</div>
    <div>Easting</div>
    <div>Elevation</div>
  </div>
);

const JointLabelsRow = () => (
  <Grid left={<LabelsRow />} right={<LabelsRow />} />
);

export default JointLabelsRow;
